module.exports = __webpack_public_path__ + "img/anhnenhome.4fbd1616.jpg";